import React from 'react';
import cn from 'classnames';
import JournalDumbView from '../../../DeviationViews/Dumbo/Journal';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import s from './Journal.scss';
const JournalView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(JournalDumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
JournalView.displayName = 'JournalView';
export default JournalView;

//# sourceMappingURL=Journal.js.map